import React from 'react';
import { formatNumber } from '../../services';
import * as S from './claim-financial-summary.styles';
import { ClaimFinancialSummaryData } from './claim-financial-summary.utils';

const formatAmount = formatNumber('Currency');

interface IFinancialCardProps {
    title: string;
    value: number;
}

const FinancialCard: React.FC<IFinancialCardProps> = ({ title, value }) => (
    <S.FinancialCard>
        <S.FinancialCardTitle>{title}</S.FinancialCardTitle>
        <S.FinancialCardValue $isZero={value === 0}>{formatAmount(value)}</S.FinancialCardValue>
    </S.FinancialCard>
);

interface IClaimFinancialSummaryProps {
    financials: ClaimFinancialSummaryData;
}

export const ClaimFinancialSummary: React.FC<IClaimFinancialSummaryProps> = ({ financials }) => (
    <S.FinancialCardsRow>
        <FinancialCard title="Charge" value={financials.charge} />
        <FinancialCard title="Contract Value" value={financials.contractValue} />
        <FinancialCard title="Allowed" value={financials.allowed} />
        <FinancialCard title="Payer Paid" value={financials.payerPaid} />
        <FinancialCard title="Patient Resp." value={financials.patientResponsibility} />
        <FinancialCard title="Patient Paid" value={financials.patientPaid} />
        <FinancialCard title="Outstanding" value={financials.outstanding} />
    </S.FinancialCardsRow>
);
